import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Bueno, arranquemos viendo los requerimientos para correr todo:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Windows`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`MacOS`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Linux`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://brew.sh/"
            }}>{`Homebrew`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://brew.sh/"
            }}>{`Homebrew`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Xcode Command Line Tools `}<br />{` `}<strong parentName="td">{`(xcode-select --install)`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://nodejs.org/es/"
            }}>{`NodeJS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node.js `}<strong parentName="td">{`(brew install node)`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node.js `}<strong parentName="td">{`(brew install node)`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.atlassian.com/git/tutorials/install-git#windows"
            }}>{`Git`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.atlassian.com/git/tutorials/install-git#mac-os-x"
            }}>{`Git`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.atlassian.com/git/tutorials/install-git#linux"
            }}>{`Git`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gatsby-CLI `}<br />{` `}<strong parentName="td">{`(npm i -g gatsby-cli)`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gatsby-CLI `}<br />{` `}<strong parentName="td">{`(npm i -g gatsby-cli)`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gatsby-CLI `}<br />{` `}<strong parentName="td">{`(npm i -g gatsby-cli)`}</strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`Genial, si instalamos todo eso ya vamos a tener a nuestra disposición el CLI
(Interfaz de Línea de Comandos) de Gatsby para poder hacer muchas cosas, veamos
algunos comandos que nos ofrece y que vamos a usar seguido:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`gatsby new <Nombre_proyecto> <Starter_opcional>`}</strong>{`: Comando para empezar a
hacer una web app en Gatsby en la carpeta Nombre_proyecto. Si queremos podemos
definir un "starter", aunque si no ponemos nada, hay uno por default con una
buena base de cosas preinstaladas.`}</li>
      <li parentName="ul"><strong parentName="li">{`gatsby develop`}</strong>{`: Corre un entorno local de desarrollo para ver nuestra app.`}</li>
      <li parentName="ul"><strong parentName="li">{`gatsby build`}</strong>{`: Genera una carpeta "public" con nuestra web app lista para
producción.`}</li>
    </ul>
    <p>{`Empecemos entonces creando nuestro proyecto en una carpeta que querramos, yo en
este caso voy a llamarlo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`miPortfolio`}</code>{` y voy a usar el starter por defecto,
ustedes ponganle el nombre que más les guste 😀`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`gatsby new miPortfolio
`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` miPortfolio`}</code></pre></div>
    <p>{`Tomémonos un segundo para abrir esta carpeta con nuestro proyecto en nuestro
editor preferido de texto (`}<a parentName="p" {...{
        "href": "https://code.visualstudio.com/download"
      }}>{`VS Code`}</a>{` en
mi caso) y estudiemos un poco los archivos y las carpetas que tiene, nos va a
servir saber qué hace cada cosa para no dar pasos en falso y que luego no
tengamos dolores de cabeza intentando entender qué es lo que está pasando cuando
modifiquemos cosas.`}</p>
    <Image imgName="files.png" alt="Archivos de nuestro proyecto" style={{
      width: '30vw',
      margin: '0 auto'
    }} mdxType="Image" />
    <h2>{`Archivos del proyecto`}</h2>
    <p>{`Empecemos por los archivos importantes propios de Gatsby, son esos 4 que están
afuera de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`src`}</code>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-config/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`gatsby-config`}</code></a>{`:
Este es un archivo fundamental para nuestro proyecto, acá van a estar todas
las configuraciones de nuestros plugins, además de la metadata de nuestra
página y otras configuraciones generales.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-node/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`gatsby-node`}</code></a><strong parentName="li">{`*`}</strong>{`:
Todo el código que esté en este archivo va a correr durante el proceso de
`}<em parentName="li">{`build`}</em>{` de nuestra página. Se puede usar para crear páginas de forma dinámica,
agregar nodos en GraphQL o responder a eventos que suceden durante el `}<em parentName="li">{`build`}</em>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-browser/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`gatsby-browser`}</code></a><strong parentName="li">{`*`}</strong>{`:
Mediante este archivo vamos a poder responder a acciones dentro del browser y
también nos permite `}<em parentName="li">{`wrappear`}</em>{` nuestra página dentro de componentes. Nos
permite interactuar con la parte `}<em parentName="li">{`client-side`}</em>{` de Gatsby.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-ssr/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`gatsby-ssr`}</code></a><strong parentName="li">{`*`}</strong>{`:
Aquí podemos alterar el contenido de los HTML mientras están siendo
`}<em parentName="li">{`Server-Side Rendered (SSR)`}</em>{` (o renderizados del lado del servidor) por Gatsby
y Node.js.`}</li>
    </ul>
    <p><em parentName="p">{`Cada uno de estos archivos tiene una entrada en las docs de Gatsby, si cliquean
en los nombres de cada uno pueden leer más sobre cada uno.`}</em></p>
    <p>{`Ahora, por qué todos tienen un asterisco salvo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config`}</code>{`, se preguntarán?
Bueno, es porque es el único `}<strong parentName="p">{`estrictamente necesario`}</strong>{` para que nuestra página
en Gatsby funcione, los otros tres son opcionales. Y si quieren leer más sobre
las APIs disponibles en cada uno de los archivos opcionales, les dejo los links
de la documentación para
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/node-apis/"
      }}>{`Gatsby Node APIs`}</a>{`,
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/browser-apis/"
      }}>{`Gatsby Browser APIs`}</a>{` y
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/ssr-apis/"
      }}>{`Gatsby SSR APIs`}</a>{`.`}</p>
    <h2>{`Carpetas del proyecto`}</h2>
    <p>{`Para las carpetas vamos a ver pocas realmente importantes en nuestro proyecto
ahora, pero hay otras que tienen su grado de importancia dependiendo de lo que
estemos haciendo, veamos:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`/src`}</code>{`: En esta carpeta va a estar todo el código de lo que veamos en el
frontend de nuestra página.`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.gatsbyjs.org/docs/recipes/#creating-pages"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`/pages`}</code></a>{`: Esta
carpeta es medio `}<em parentName="li">{`mágica ✨`}</em>{` porque por cada componente que creemos acá,
Gatsby va a crear automáticamente una ruta con el nombre. (Salvo por index y
404 jajaja. Por ejemplo, si creo el archivo `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`about.js`}</code>{`, automáticamente
podemos ingresar a `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`/about`}</code>{` y vamos a ver lo que pongamos en ese componente
recién creado)`}</li>
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`/components`}</code>{`: Como su nombre lo indica, acá van a estar los componentes que
usemos en nuestras `}<em parentName="li">{`pages`}</em>{`.`}</li>
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`/images`}</code>{`: Acá pondremos todas las imágenes que usemos. Si vemos el archivo
`}<code parentName="li" {...{
              "className": "language-text"
            }}>{`gatsby-config.js`}</code>{` vemos que ya está configurada esta carpeta para
aprovechar la optimización de imágenes de Gatsby.`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.gatsbyjs.org/docs/building-with-components/#page-template-components"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`/templates`}</code></a>{`:
Esta carpeta no está en nuestro proyecto pero es útil para definir templates
con data que venga de algún otro archivo de Gatsby, uno que genere páginas y
necesite una estructura como template.`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-browser/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`/.cache`}</code></a>{`:
`}<em parentName="li">{`Generada automáticamente por Gatsby`}</em>{`, esta carpeta la genera Gatsby en `}<em parentName="li">{`build
time`}</em>{` y va a tener un cache interno y no debemos modificarla.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/api-files-gatsby-ssr/"
        }}><code parentName="a" {...{
            "className": "language-text"
          }}>{`/public`}</code></a>{`: `}<em parentName="li">{`Generada
automáticamente por Gatsby`}</em>{`, los archivos generados luego del `}<em parentName="li">{`build process`}</em>{`
van a parar a esta carpeta. Va a contener los HTML, CSS, JS y demás archivos
de nuestro proyecto generados de tal forma que podríamos copiar los contenidos
de la carpeta en un host "común" y levantaría nuestra página tal como la vimos
mientras la estábamos desarrollando.`}</li>
    </ul>
    <h2>{`Routing`}</h2>
    <p>{`Esta es (para mi) una de las mejores cosas de Gatsby, tiene `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Reach-router`}</code>{`
(próximamente se fusiona con `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`React-router`}</code>{`) preconfigurado para que genere una
ruta nueva cada vez que creemos un archivo en la carpeta `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`src/pages`}</code>{`. Hay otra
forma de crear páginas desde el archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{`, pero vamos a verlo más
adelante.`}</p>
    <p>{`Además, para navegar entre páginas de nuestro proyecto, Gatsby nos provee de un
componente llamado `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/gatsby-link/"
      }}><strong parentName="a">{`gatsby-link`}</strong></a>{`
el cual nos provee de algunas bondades como prefetching, lo que hace que las
transiciones entre páginas sean casi instantáneas. 😉`}</p>
    <h2>{`Imágenes y lazy loading`}</h2>
    <p>{`Alguna vez vieron el efecto "blur-up" ese que está en los posts de Medium? No?
Bueno, Gatsby tiene optimización de imágenes GRATIS y con configuración mínima
(en el caso del starter por default, ya viene configurado así que no tendríamos
que hacer nada). Gatsby nos propone dos formas de mostrar nuestras imágenes:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`Fluid`}</code>{`: Gatsby crea distintos tamaños flexibles de nuestras imágenes que se
adaptan al contenedor donde las usemos. Por ejemplo, si el `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`max-width`}</code>{` del
contenedor es 800px, se van a crear imágenes de los tamaños 200px, 400px,
800px, 1200px y 1600px; lo necesario para que Gatsby después cargue la más
óptima según el tamaño de dispositivo o resolución de pantalla.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`Fixed`}</code>{`: Gatsby crean distintos tamaños de imágenes para diferentes
resoluciones pero con un `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`width`}</code>{` y `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`height`}</code>{` fijos. Crea imágenes a 1x, 1.5x y
2x para luego cargar la que considere más óptima.`}</li>
    </ul>
    <p>{`Para ver los diferentes efectos que podemos usar durante la precarga de las
imágenes, podemos entrar en
`}<a parentName="p" {...{
        "href": "https://using-gatsby-image.gatsbyjs.org/"
      }}>{`este link`}</a>{`.`}</p>
    <p>{`Probemos cómo se ve por ahora nuestro proyecto y chequeemos la velocidad que
tiene para pasar entre páginas usando el comando `}<strong parentName="p">{`gatsby develop`}</strong>{` 🚀🚀🚀🚀🚀`}</p>
    <p>{`Bueno, hasta ahora pudimos ver un poco de la estructura del proyecto por default
que nos provee Gatsby, pero con esto solamente estamos raspando la superficie y
cada tema se puede ahondar muchísimo más. Vamos a la próxima parte donde vamos a
hablar del sistema de Plugins que tiene Gatsby que es `}<strong parentName="p">{`hermoso`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      